import { render, staticRenderFns } from "./RemoteZoneRight.vue?vue&type=template&id=2ec0526d&scoped=true"
import script from "./RemoteZoneRight.vue?vue&type=script&lang=js"
export * from "./RemoteZoneRight.vue?vue&type=script&lang=js"
import style0 from "./RemoteZoneRight.vue?vue&type=style&index=0&id=2ec0526d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0526d",
  null
  
)

export default component.exports